export const UNNAMED_GROUP_CONFIRMATION =
  'Create this group without a group name?\n\n'
  + 'The group name is used on the client’s group-download button and as the ZIP filename. '
  + 'Without one, clients will see the generic name “Dateigruppe”.';

export function confirmUnnamedGroupCreation(
  title: string,
  ask: (message: string) => boolean = (message) => window.confirm(message),
): boolean {
  return title.trim().length > 0 || ask(UNNAMED_GROUP_CONFIRMATION);
}